import axios from 'axios'
import { ENV } from '@constants/env'

/**
 * Primary Axios instance for the After Summit API.
 *
 * The backend does NOT use JWT. Authentication is session-based:
 * the current user's _id is stored in localStorage and passed as
 * userId in request bodies / query params where required.
 *
 * Responsibilities:
 *  - Base URL from environment
 *  - Default headers
 *  - Response interceptor → unwrap data, handle auth errors globally
 */
const apiClient = axios.create({
  baseURL: ENV.BACKEND_URL,
  timeout: 15_000,
  headers: {
    'Content-Type': 'application/json',
    Accept:         'application/json',
  },
})

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('agrocast_access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// ── Response Interceptor ────────────────────────────────────────────────────
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Fire global logout event on 401 so AuthProvider can react
    if (error.response?.status === 401) {
      window.dispatchEvent(new CustomEvent('auth:logout'))
    }
    return Promise.reject(normalizeError(error))
  }
)

// ── Error Normalizer ────────────────────────────────────────────────────────

function normalizeError(error) {
  const status  = error.response?.status
  const message = error.response?.data?.message ?? error.message ?? 'An unexpected error occurred'

  return {
    status,
    message,
    errors:        error.response?.data?.errors ?? null,
    originalError: error,
  }
}

export default apiClient
